import React, { useState } from "react";
import Treefold from "react-treefold";
import { List, ListItem, ListItemText } from "@material-ui/core";

const MatrixComponent = ({ matrix }) => {
  const [expandedNodes, setExpandedNodes] = useState({});

  const renderNode = ({
    node,
    level,
    isFolder,
    isExpanded,
    getToggleProps,
    hasChildNodes,
    renderChildNodes,
  }) => {
    return (
      <div style={{ marginLeft: level * 20 }}>
        <ListItem
          button
          onClick={getToggleProps().onClick}
          style={{
            backgroundColor: "#f0f0f0", // light gray background
            border: "1px solid #ccc", // gray border
            borderRadius: "5px", // rounded corners
            marginBottom: "10px", // space between items
          }}
        >
          <ListItemText
            primary={`User: ${node.referral}, Level: ${node.level_number}, Sameline: ${node.sameline_number}`}
          />
        </ListItem>
        {isExpanded && (
          <List component="div" disablePadding>
            {renderChildNodes()}
          </List>
        )}
      </div>
    );
  };

  return (
    <Treefold
      nodes={matrix}
      render={renderNode}
      isNodeExpanded={(node) => expandedNodes[node.referral]}
      onToggleExpand={(node) => {
        setExpandedNodes({
          ...expandedNodes,
          [node.referral]: !expandedNodes[node.referral],
        });
      }}
    />
  );
};

export default MatrixComponent;
